import { render, staticRenderFns } from "./CreateContactOtherPage.vue?vue&type=template&id=4a6f680c&scoped=true"
import script from "./CreateContactOtherPage.vue?vue&type=script&lang=js"
export * from "./CreateContactOtherPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f680c",
  null
  
)

export default component.exports